module.exports = __webpack_public_path__ + "static/media/provider_id.3832b6f0.png";